import { useEffect, useRef } from "react";
import { TopNavBar } from "@/layouts/TopNavBar/TopNavBar";
import { FdEditor } from "./components/FdEditor/FdEditor";
import { FdViewer } from "./components/FdViewer/FdViewer";
import { useMediaQuery } from "@mui/material";
import { FdLinkAlert } from "./components/FdLinkAlert/FdLinkAlert";
import { LinkCategoryContextProvider } from "./contexts/LinkCategoryContextProvider";
import { FdTab } from "./components/FdTab/FdTab";
import { useQueryParamsHook } from "@/hooks/useQueryParamsHook";
import { FdInflowAnalytics } from "./components/FdInflowAnalytics/FdInflowAnalytics";
import { WegetNotice } from "./components/weget-notice/WegetNotice";
import { FdDesignSetting } from "./components/FdDesignSetting/FdDesignSetting";
import { FdMobilePreview } from "./components/FdMobilePreview/FdMobilePreview";
import { FdApiSetting } from "./components/FdApiSetting/FdApiSetting";
import { FdShortLink } from "./components/FdShortLink/FdShortLink";
import { FdProposal } from "./components/FdProposal/FdProposal";
import { FdSubscription } from "./components/FdSubscription/FdSubscription";
import { FdPosts } from "./components/FdPosts/FdPosts";
import { FdPostPreview } from "./components/FdPosts/FdPostPreview";
import { FdSurveys } from "./components/FdSurveys/FdSurveys";
import { FdSurveyPreview } from "./components/FdSurveys/FdSurveyPreview";

export function MainView(props) {
    return (
        <LinkCategoryContextProvider>
            <MainViewCore />
        </LinkCategoryContextProvider>
    );
}

function MainViewCore() {
    const queryParamsHook = useQueryParamsHook();
    const tabType = queryParamsHook?.params?.tabType;
    const isWritingPost = tabType === 'POSTS' && !!queryParamsHook?.params?.postId; // 글 쓰는 중엔 오른쪽이 글 미리보기
    const isEditingSurvey = tabType === 'SURVEYS' && !!queryParamsHook?.params?.surveyId && queryParamsHook?.params?.surveyView !== 'RESULTS'; // 설문 고치는 중엔 설문 미리보기

    const previewRef = useRef();
    const mobileView = useMediaQuery('(max-width: 992px)');

    const handleRefreshPreviewViewer = () => {
        if (!mobileView) {
            previewRef.current.src += '';
        }
    }

    const tabTypeList = TAB_LIST?.map(r => r.type);

    return (
        <div className="min-h-screen bg-[#f5f5f7]">
            <TopNavBar />
            <main className="min-[993px]:mr-[435px]">
                <div className="mx-auto flex max-w-[760px] flex-col gap-5 px-3 pb-40 pt-5 sm:px-6">
                    <FdLinkAlert />
                    <FdTab
                        TAB_LIST={TAB_LIST}
                    />
                    {tabType === 'INFLOW_ANALYTICS' &&
                        <FdInflowAnalytics />
                    }
                    {tabType === 'API_SETTING' &&
                        <FdApiSetting />
                    }
                    {tabType === 'POSTS' &&
                        <FdPosts />
                    }
                    {tabType === 'SURVEYS' &&
                        <FdSurveys />
                    }
                    {tabType === 'SHORT_LINK' &&
                        <FdShortLink />
                    }
                    {tabType === 'PROPOSAL' &&
                        <FdProposal
                            onRefreshPreviewViewer={handleRefreshPreviewViewer}
                        />
                    }
                    {tabType === 'PLAN' &&
                        <FdSubscription />
                    }
                    {tabType === 'DESIGN_SETTING' &&
                        <FdDesignSetting
                            onRefreshPreviewViewer={handleRefreshPreviewViewer}
                        />
                    }
                    {(!tabType || tabType === 'PAGE_MANAGE' || !tabTypeList?.includes(tabType)) &&
                        <FdEditor
                            onRefreshPreviewViewer={() => handleRefreshPreviewViewer()}
                        />
                    }
                </div>
            </main>
            {!mobileView && isWritingPost &&
                <FdPostPreview />
            }
            {!mobileView && isEditingSurvey &&
                <FdSurveyPreview />
            }
            {!mobileView && !isWritingPost && !isEditingSurvey &&
                <FdViewer
                    ref={previewRef}
                />
            }
            {mobileView &&
                <FdMobilePreview />
            }
            <WegetNotice />
        </div>
    );
}

const TAB_LIST = [
    {
        type: 'PAGE_MANAGE',
        name: '페이지 관리',
        default: true,
    },
    {
        type: 'POSTS',
        name: '이야기',
        default: false,
    },
    {
        type: 'SURVEYS',
        name: '설문',
        default: false,
    },
    {
        type: 'DESIGN_SETTING',
        name: '디자인 설정',
        default: false,
    },
    {
        type: 'INFLOW_ANALYTICS',
        name: '유입분석',
        default: false,
    },
    {
        type: 'PROPOSAL',
        name: '받은 제안',
        default: false,
    },
    {
        type: 'SHORT_LINK',
        name: '단축 URL',
        default: false,
    },
    {
        type: 'API_SETTING',
        name: 'API 연동',
        default: false,
    },
    {
        type: 'PLAN',
        name: '요금제',
        default: false,
    },
]